const infos = {

  // Shop-Variablen
  title: 'homeylove – Home & Living für dein Zuhause',
  name: 'homeylove.de',
  url: 'https://www.homeylove.de/',
  email: 'info@homeylove.de',
  //telephone: '0202/43044332',
  telephone: undefined as string | undefined,
  fax: '0202/43044350',
  publicher: 'homeylove',
  priceRange: '$', // Wie Teuer sind wir?   1-5  // 1 = Billig  2 = Normal  5 = SUPER-TEUER!!!

  // SHOP INFOS
  description: 'Mehr Farbe. Mehr Zuhause. Entdecke bei homeylove schöne Wohnaccessoires, weiche Textilien und Geschirr für deinen Alltag.',
  titleAlternate: 'homeylove',
  host: 'www.homeylove.de',
  locale: 'de_DE',
  currency: 'EUR',

  // LEGAL INFOS
  legalowner: 'Angelina Minardi',
  legalname: 'homeylove.de',
  street: 'Alfredstr. 18',
  postalcode: '42281',
  locality: 'Wuppertal',
  region: 'Nordrhein-Westfalen',
  regionCode: 'DE-NW',
  countryCode: 'DE',

  registergericht: null as string | null, // 'Amtsgericht ???'
  registernummer: null as string | null, // 'HRB ?????'
  umsatzsteuernr: 'DE 355655005',

  // Konfiguration
  paymentAfterCheckout: false as boolean, // true = Zahlung nach Bestellung, false = Zahlung vor Bestellung
  siteId: 1,
  containerId: "St2EXJ8V",
} as const

export default infos
